.field {
	display: grid;
	gap: var(--space-2);
	color: var(--ink-muted);
}

/* Deliberately on the label rather than the wrapper: inherited onto a control
   it would put every input at 14.4px, which is below the 16px threshold at
   which iOS Safari zooms the viewport on focus. */
.label {
	font-size: 0.9rem;
}

/* Uppercase micro-heading — the treatment the recipe forms use. */
.captionLabel {
	font-size: 0.75rem;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
}

.field input,
.field textarea,
.field select {
	width: 100%;
	padding: var(--space-3) var(--space-4);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	font: inherit;
	background: var(--surface-input);
	color: var(--ink);
}

.field input:focus-visible,
.field textarea:focus-visible,
.field select:focus-visible {
	outline: 2px solid var(--accent-sage);
	outline-offset: 2px;
	border-color: transparent;
}

.hint {
	font-size: 0.8rem;
	line-height: 1.4;
	text-wrap: pretty;
}

.error {
	font-size: 0.8rem;
	line-height: 1.4;
	color: color-mix(in oklab, var(--accent-rose) 70%, black);
}
